import {createContext} from 'react';
import {User, HexofyUser} from './../types';

export const UserContext = createContext({
  user: null as null | User,
  setUser: (user: User | null) => {},
  hexofyUser: null as HexofyUser | null,
  setHexofyUser: (hexofyUser: HexofyUser | null) => {},
});
